import { WorksheetCard } from './worksheet-card';

function setCards() {
  const cards = document.getElementsByClassName('paid-materials-card');

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < cards.length; i++) {
    const card = new WorksheetCard({ card: cards[i] });

    card.init();
  }
}

setCards();
